module.exports = __webpack_public_path__ + "img/electronic.e23c1acc.jpg";